import React, { useEffect, useState } from 'react';
import './ShareRow.css';

const canNativeShare = () => typeof navigator !== 'undefined' && typeof navigator.share === 'function';

async function copyText(text) {
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch {
    const field = document.createElement('textarea');
    field.value = text;
    field.setAttribute('readonly', '');
    field.style.position = 'fixed';
    field.style.opacity = '0';
    document.body.appendChild(field);
    field.select();
    const ok = document.execCommand('copy');
    document.body.removeChild(field);
    return ok;
  }
}

const ShareRow = ({
  url,
  text,
  title,
  label = 'Share',
  compact = false,
  shareLabel = 'Share…',
  copyLabel = 'Copy link',
  copiedLabel = 'Copied',
}) => {
  const [copied, setCopied] = useState(false);
  const [native, setNative] = useState(false);
  useEffect(() => setNative(canNativeShare()), []);
  const fullUrl = url.startsWith('http') ? url : `https://nowtarot.com${url}`;
  const message = text ? `${text} ${fullUrl}` : fullUrl;

  const handleNative = async () => {
    try {
      await navigator.share({ title: title || text, text, url: fullUrl });
    } catch {
      // The visitor closed the share sheet.
    }
  };

  const handleCopy = async () => {
    if (await copyText(fullUrl)) {
      setCopied(true);
      setTimeout(() => setCopied(false), 2200);
    }
  };

  const encoded = encodeURIComponent(fullUrl);
  const encodedText = encodeURIComponent(text || '');

  return (
    <div className={`share-row${compact ? ' compact' : ''}`}>
      {label && <span className="share-row-label">{label}</span>}
      <div className="share-row-buttons">
        {native && (
          <button type="button" className="share-row-primary" onClick={handleNative}>{shareLabel}</button>
        )}
        <button type="button" onClick={handleCopy}>{copied ? `${copiedLabel} ✓` : copyLabel}</button>
        <a href={`https://wa.me/?text=${encodeURIComponent(message)}`} target="_blank" rel="noopener noreferrer">WhatsApp</a>
        <a href={`https://twitter.com/intent/tweet?text=${encodedText}&url=${encoded}`} target="_blank" rel="noopener noreferrer">X</a>
        <a href={`https://www.facebook.com/sharer/sharer.php?u=${encoded}`} target="_blank" rel="noopener noreferrer">Facebook</a>
      </div>
    </div>
  );
};

export default ShareRow;
